import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import TaskForm from "../formPages/TaskForm";
import OwnerRecipientsDashboard from "./OwnerRecipientsDashboard";
import AddUserForm from "../usersForm/AddUserForm";
import SharedUserPicker from "../usersForm/SharedUserPicker";
import { ShareButton } from "./ShareButton";
import "../App.css"
import "../stylesheets/Home.css";

export function Home() {
  const { user } = useAuth();
  const [selectedUsers, setSelectedUsers] = useState([]);

  return (
    <div className="todo-list-main">
      <div className="user-info">        
        <h1 className="title-description">
          ¡Hola {(
            user?.displayName
              ? user.displayName.trim().split(/\s+/)[0]
              : user?.email
          )}!
        </h1>
      </div>
      <div className="home-grid">        
        <section className="home-left">
          <p className="text-center text-sm py-2">
            Podrás agregar notas, enlaces o recursos
          </p>
          <TaskForm
            selectedUsers={selectedUsers}
            onClearSelectedUsers={() => setSelectedUsers([])}
          />
          <div className="share-btn-container">
            <ShareButton mode="perfil" />
          </div>
        </section>
        <section className="home-right">
          <p className="text-center text-sm py-2">
            Añade contactos para que puedan compartir recursos.
          </p>
          <AddUserForm onContactAdded={() => setSelectedUsers([])} />
          <div className="user-select-wrapper">
            <SharedUserPicker onUserSelected={setSelectedUsers} />
          </div>
        </section>
        <section className="home-bottom">
          <OwnerRecipientsDashboard />
        </section>
      </div>
    </div>
  );
}
